import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import styles from './Layout.module.css';

export function Layout() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className={styles.layout}>
      <Header />
      <main className={`${styles.main} ${isHomePage ? styles.fullWidth : ''}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
